import { BaseError, ErrorChanel } from './base-error';

export class HttpSSError extends BaseError {
  public key: any;
  public chanel: ErrorChanel = ErrorChanel.QA;
  public type = 'HttpSS';
  public name = 'HttpSS';

  constructor(key: any) {
    super(`Error in SS request: ${JSON.stringify(key)}`);
    this.key = `${key.message}`;
  }
}
